import { Link } from 'found';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { injectIntl } from 'react-intl';

import Loading from 'src/components/Loading';
import Breadcrumbs from 'src/enosikit/components/Breadcrumbs';
import InviteCustomerUserMutation from 'src/mutations/InviteCustomerUserMutation';
import FlashesStore from 'src/stores/FlashesStore';

import AdminUserInviteCustomerForm from './AdminUserInviteCustomerForm';
import AdminUserControls from '../AdminUserControls';

class AdminUserInviteCustomer extends React.Component {
  static mutationName = 'adminUserInviteCustomer';

  constructor(props) {
    super(props);

    this.state = {
      processing: false,
    };
  }

  handleAdminUserInviteCustomer = (input) => {
    this.setState({ processing: true });
    FlashesStore.reset();

    InviteCustomerUserMutation(
      input,
      this.handleAdminUserInviteCustomerSuccess,
      this.handleAdminUserInviteCustomerFailure,
    );
  };

  handleAdminUserInviteCustomerSuccess = (response, errors) => {
    this.setState({ processing: false });
    const { intl } = this.props;

    if (errors && errors.length > 0) {
      errors.forEach((error) => FlashesStore.flash(FlashesStore.ERROR, {
        message: FlashesStore.ERROR,
        source: {
          errors: [error],
        },
      }, AdminUserInviteCustomer.mutationName));
      return;
    }

    const { uuid, email } = response.inviteCustomerUser;

    FlashesStore.flash(
      FlashesStore.SUCCESS,
      intl.formatMessage(
        {
          id: 'admin.admin_user.admin_user_invite_customer.response_message.success',
          defaultMessage: 'An email invitation has been sent to {emailLink} to finish their account registration.',
        },
        {
          emailLink: <Link to={`/admin/users/${uuid}`}>{email}</Link>,
        },
      ),
      AdminUserInviteCustomer.mutationName,
    );

    const { router } = this.props;
    router.push('/admin/users/');
  };

  handleAdminUserInviteCustomerFailure = (error) => {
    this.setState({ processing: false });

    FlashesStore.flash(FlashesStore.ERROR, error, AdminUserInviteCustomer.mutationName);
  };

  render() {
    const { intl } = this.props;
    const errorMessage = intl.formatMessage({
      id: 'admin.admin_user.admin_user_invite_customer.form.state.error',
      defaultMessage: 'Error!',
    });

    if (this.error) {
      return <div>{errorMessage}</div>;
    }
    if (!this.props) {
      return <Loading />;
    }

    const { processing } = this.state;

    // Page title translations
    const pageTitle = intl.formatMessage({
      id: 'admin.admin_user.admin_user_invite_customer.page.title',
      defaultMessage: 'Enosi - Admin - Users - Invite Customer',
    });

    // Breadcrumb translations
    const breadcrumbAdmin = intl.formatMessage({
      id: 'admin.admin_user.admin_user_invite_customer.breadcrumb.admin',
      defaultMessage: 'Admin',
    });
    const breadcrumbUsers = intl.formatMessage({
      id: 'admin.admin_user.admin_user_invite_customer.breadcrumb.users',
      defaultMessage: 'Users',
    });
    const breadcrumbInviteNewCustomer = intl.formatMessage({
      id: 'admin.admin_user.admin_user_invite_customer.breadcrumb.invite_new_customer',
      defaultMessage: 'Invite new customer',
    });

    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{pageTitle}</title>
        </Helmet>

        <Breadcrumbs
          breadcrumbs={[
            { name: breadcrumbAdmin, path: '/admin' },
            { name: breadcrumbUsers, path: '/admin/users' },
            { name: breadcrumbInviteNewCustomer },
          ]}
        />
        <div className="clearfix">
          <div className="float-end mb-3">
            <AdminUserControls />
          </div>
        </div>

        <AdminUserInviteCustomerForm
          handleInvite={this.handleAdminUserInviteCustomer}
          processing={processing}
        />
      </>
    );
  }
}

AdminUserInviteCustomer.propTypes = {
  relay: PropTypes.shape({
    refetch: PropTypes.func,
  }).isRequired,
  router: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  intl: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default injectIntl(AdminUserInviteCustomer);
